import { MenuRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Obtener_Menu_Request = async (pToken) => {
    const result = await fetch(MenuRutas.Obtener_Menu, {
        method: 'GET',
        headers: GetHeaderRequest(pToken)
    });
    return await GetResponseBody(result);
};

export const Obtener_MenuOpciones = async (pToken, Menu_Id) => {
    const result = await fetch(MenuRutas.Obtener_MenuOpciones+'?Menu_Id='+ Menu_Id.toString(), {
        method: 'GET',
        headers: GetHeaderRequest(pToken)
    });
    return await GetResponseBody(result);
};

export const Seg_Usuario_Validar_Opcion = async (pToken, Menu_Id, Opcion_Id, Usuario, Contrasena, Empresa_Id, Sucursal_Id, ActivoAD) => {
    const data = { Menu_Id, Opcion_Id, Usuario, Contrasena, Empresa_Id, Sucursal_Id, ActivoAD };
    const result = await fetch(MenuRutas.Seg_Usuario_Validar_Opcion, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};